import React, { useState, useEffect } from "react";
// Custom CSS for styling

const BannerSlider = () => {
  const banners = [
    {
      image: "assets/img/Bracademy/brbanner-1.jpg",
      title: "Expert education, personalized support ",
      description:
        "Achieve your best with BR Academy, expert coaching, proven strategies, and personalized guidance for your success. ",
      link: "https://www.bracadmy.com/technical-topic/",
    },
    {
      image: "assets/img/Bracademy/brbanner-2.jpg",
      title: "Your path to the best",
      description:
        "BR Academy provides a supportive learning atmosphere that helps you achieve your goals.",
      link: "https://www.bracadmy.com/technical-topic/",
    },
    {
      image: "assets/img/Bracademy/brbanner-3.jpg",
      title: "Learning made Hilarious",
      description:
        "Our Academy empowers students from all backgrounds and experience levels.",
      link: "https://www.bracadmy.com/technical-topic/",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + banners.length) % banners.length
    );
  };

  useEffect(() => {
    const intervalId = setInterval(nextSlide, 5000); // 10 seconds interval for the slide
    return () => clearInterval(intervalId); // Cleanup on component unmount
  }, [banners.length]); // Add banners.length as a dependency

  return (
    <div className="banner-slider">
      <div className="slider-container">
        <div
          className="slider "
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {banners.map((banner, index) => (
            <div className="slide" key={index}>
              <img src={banner.image} alt={`Banner ${index + 1}`} />
              <div className="slide-content">
                <h2>{banner.title}</h2>
                <p>{banner.description}</p>
                <a className="br_banner_cta" href={banner.link}>
                  More Details
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button className="prev" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="next" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
};

export default BannerSlider;
